import { dataReportStar } from 'dls-icons-data'
import { createIcon } from '../common'

const IconReportStar = /*#__PURE__*/createIcon(dataReportStar)
export default IconReportStar
